import { ProductTagBase } from '../ProductTagBase';
import { differenceInHours, differenceInSeconds } from 'date-fns';
import klass from '../style/ProductTag.module.scss';

/**
 * @figma
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60347&m=dev
 */
export class UpcomingTag extends ProductTagBase<Date> {
  protected override makeLabel(): string | undefined {
    const currentTime = new Date();
    const saleStartDate = this.data.value;
    const hoursLeft = differenceInHours(saleStartDate, currentTime);
    const secondsLeft = differenceInSeconds(saleStartDate, currentTime);

    if (hoursLeft >= 24) {
      // `출시 N일 전이에요!`
      const daysLeft = Math.floor(hoursLeft / 24);
      return ET('mps2::product::tag::upcoming_day', {
        day: daysLeft,
        lng: this.data.lang,
      });
    } else if (hoursLeft >= 1) {
      // `출시 N시간 전이에요!`
      return ET('mps2::product::tag::upcoming_hour', {
        hour: hoursLeft,
        lng: this.data.lang,
      });
    } else if (hoursLeft === 0 && secondsLeft > 60) {
      // `출시 N분 전이에요!`
      const minutesLeft = Math.floor(secondsLeft / 60);
      return ET('mps2::product::tag::upcoming_min', {
        minute: minutesLeft,
        lng: this.data.lang,
      });
    } else if (hoursLeft === 0 && secondsLeft > 0 && secondsLeft <= 60) {
      // `곧 출시해요!`
      return ET('mps2::product::tag::upcoming_soon', {
        second: secondsLeft,
        lng: this.data.lang,
      });
    }
  }

  protected styles(): string {
    return klass.upcoming;
  }

  isTimerNeeded(): boolean {
    return true;
  }
}
